import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill", "width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'CloseIcon',
  props: {
    fill: {
      type: String,
      default: 'black',
    },
    size: {
      type: [String, Number],
      default: '24',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    fill: __props.fill,
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})